import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import {
  addColor,
  deleteColor,
  getAllColors,
  updateColor,
} from "../../../services/color.service";
import { useSelector } from "react-redux";

const ColorMaster = () => {
  const [colors, setColors] = useState([]);
  const [newColor, setNewColor] = useState("");
  const [editColorId, setEditColorId] = useState(null);
  const [editColorValue, setEditColorValue] = useState("");
  const { token } = useSelector((state) => state?.auth);

  const fetchColors = async () => {
    try {
      const res = await getAllColors(token);
      if (res && res.status >= 200 && res.status < 300) {
        setColors(res.data);
      } else {
        Swal.fire("Error", "Failed to fetch colors.", "error");
      }
    } catch (error) {
      console.error("Error fetching colors:", error);
      Swal.fire("Error", "Network or server error occurred.", "error");
    }
  };

  useEffect(() => {
    fetchColors();
  }, []);

  const handleAddColor = async () => {
    if (newColor.trim() === "") {
      Swal.fire("Error", "Please enter a valid color", "error");
      return;
    }

    try {
      const res = await addColor(token, { color_name: newColor.trim() });
      if (res && res.status >= 200 && res.status < 300) {
        Swal.fire("Success", "Color added successfully", "success").then(() => {
          fetchColors();
          setNewColor("");
        });
      } else {
        Swal.fire(
          "Error",
          res?.data?.detail || "Failed to add color.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error adding color:", error);
      Swal.fire("Error", "Network or server error occurred.", "error");
    }
  };

  const handleDeleteColor = async (colorId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This color will be permanently deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await deleteColor(token, colorId);
          if (res && res.status >= 200 && res.status < 300) {
            Swal.fire("Deleted!", "Color has been deleted.", "success").then(
              () => {
                fetchColors();
              }
            );
          } else {
            Swal.fire(
              "Error",
              res?.data?.message || "Failed to delete color.",
              "error"
            );
          }
        } catch (error) {
          console.error("Error deleting color:", error);
          Swal.fire("Error", "Network or server error occurred.", "error");
        }
      }
    });
  };

  const handleSaveEditColor = async () => {
    if (editColorValue.trim() === "") {
      Swal.fire("Error", "Please enter a valid color", "error");
      return;
    }

    try {
      const res = await updateColor(
        token,
        { color_name: editColorValue.trim() },
        editColorId
      );
      if (res && res.status >= 200 && res.status < 300) {
        Swal.fire("Success", "Color updated successfully", "success").then(
          () => {
            fetchColors();
            setEditColorId(null);
            setEditColorValue("");
          }
        );
      } else {
        Swal.fire(
          "Error",
          res?.data?.message || "Failed to update color.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error updating color:", error);
      Swal.fire("Error", "Network or server error occurred.", "error");
    }
  };

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h4 className="card-title">Product Color Master</h4>
                <Link to="/products">
                  <img
                    src="/assets/images/kidskart/icon/back-button.png"
                    alt="Back"
                  />
                </Link>
              </div>

              <div className="card-body">
                <div className="mb-4 d-flex align-items-center">
                  <input
                    type="text"
                    className="form-control me-2 input-size"
                    value={newColor}
                    onChange={(e) => setNewColor(e.target.value)}
                    placeholder="Enter new color (e.g., 'Pink')"
                  />
                  <button className="btn btn-primary" onClick={handleAddColor}>
                    Add Color
                  </button>
                </div>

                <div className="row">
                  <div className="col-xl-12">
                    <div className="table-responsive">
                      <table
                        id="example5"
                        className="table order-request2 display mb-4 dataTablesCard dataTable no-footer"
                        role="grid"
                        aria-describedby="example5_info"
                      >
                        <thead>
                          <tr role="row">
                            <th>
                              <strong className="font-w600">#</strong>
                            </th>
                            <th>
                              <strong className="font-w600">Color</strong>
                            </th>
                            <th>
                              <strong className="font-w600">Actions</strong>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {colors.map((item, i) => (
                            <tr role="row" className="odd" key={item.color_id}>
                              <td>{i + 1}</td>
                              <td>
                                {editColorId === item.color_id ? (
                                  <input
                                    type="text"
                                    className="form-control"
                                    style={{ minWidth: "200px" }}
                                    value={editColorValue}
                                    onChange={(e) =>
                                      setEditColorValue(e.target.value)
                                    }
                                  />
                                ) : (
                                  item.color_name
                                )}
                              </td>
                              <td>
                                {editColorId === item.color_id ? (
                                  <div className="d-flex">
                                    <button
                                      className="btn btn-success py-1 me-2"
                                      style={{ width: "100px" }}
                                      onClick={handleSaveEditColor}
                                    >
                                      Save
                                    </button>
                                    <button
                                      className="btn btn-secondary py-1"
                                      style={{ width: "100px" }}
                                      onClick={() => setEditColorId(null)}
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                ) : (
                                  <div className="d-flex align-items-center">
                                    <img
                                      onClick={() =>
                                        setEditColorId(item.color_id) ||
                                        setEditColorValue(item.color_name)
                                      }
                                      src="/assets/images/kidskart/icon/edit.png"
                                      alt="Edit"
                                      className="ms-3 cursor-pointer"
                                    />
                                    <img
                                      onClick={() =>
                                        handleDeleteColor(item.color_id)
                                      }
                                      src="/assets/images/kidskart/icon/trash-bin.png"
                                      className="ms-1 d-none cursor-pointer"
                                      alt="Delete"
                                    />
                                  </div>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ColorMaster;
